import isEmpty from 'lodash/isEmpty';
import {Phase, PhaseType} from '../shared/model/phase.model';
import {Application} from '../components/loan-applications/loan-application/loan-application.model';

export const getCustomPhases = (phases?: Phase[]): Phase[] =>
  phases
    ? phases
      .filter(phase => phase.type === PhaseType.CUSTOM_PHASE)
      .sort((a, b) => a.orderNo - b.orderNo)
    : [];

export const getFirstRoleId = (roleIds: number[]): string => !isEmpty(roleIds) ? roleIds[0].toString() : '';

export const filterCustomPhasesByIdOrCreationType = (phase: Phase,
                                                     applicationId: number | string,
                                                     application: Application | undefined,
                                                     loanCreationType: string | undefined,
                                                     processId: number | string): boolean => {

  if (application?.processId !== processId) {
    // If product has been changed, return the custom phase from the new product if it contains the creation type
    return containsCreationType(phase, loanCreationType);
  }

  if (!isNaN(Number(applicationId))) {
    return application?.customPhaseIds?.some(phaseId => phaseId === phase.id) || false;
  }

  return containsCreationType(phase, loanCreationType);
};

export const containsCreationType = (phase: Phase, loanCreationType: string | undefined): boolean =>
  phase.creationTypes?.some(creationType => creationType === loanCreationType) || false;
